import { Routes } from '@angular/router';
import { LoginComponent, SignupComponent, ValidateComponent, VerifyEmailComponent } from '@cosmos/angular/ui';
import { ResetGuard, AuthGuard } from '@cosmos/angular/utils';
import { PasswordRecoveryComponent } from '@cosmos/angular/ui';
import { PasswordResetComponent } from '@cosmos/angular/ui';

export const routes: Routes = [
  { path: 'login', component: LoginComponent, data: { signupAllowed: true } },
  { path: 'signup', component: SignupComponent },
  {
    path: 'validate',
    component: ValidateComponent,
    canActivate: [AuthGuard],
  },
  { path: 'verify-email', component: VerifyEmailComponent },
  { path: 'recovery', component: PasswordRecoveryComponent },
  {
    path: 'reset',
    canActivate: [ResetGuard],
    component: PasswordResetComponent,
  },
  {
    path: '',
    loadChildren: () =>
      import('./dashboard/dashboard.routes').then(
        (dashboard) => dashboard.dashboardRoutes,
      ),
  },
  { path: '**', redirectTo: '' },
];
